// Debounce function to limit the rate at which a function is called
function debounce(func, delay) {
    var inDebounce;
    return function () {
        var context = this;
        var args = arguments;
        clearTimeout(inDebounce);
        inDebounce = setTimeout(function () {
            func.apply(context, args);
        }, delay);
    }
}

/**
 * A global utility function to handle the ajaxing and loading of posts.
 * For usage with the filter on-click functionality and the "Load More" button
 * functionality for any archive (blog, case studies, etc.).
 *
 * @param {jQuery} $buttonElement The "Load More" button element as a jQuery object.
 * @param {object} data           Any data passed into the Ajax `data` parameter
 *                                (e.g. `action`, `category`). `paged` is added automatically.
 * @param {string} insertMode     "append" (default) or "replace".
 * @param {object} options        Optional overrides for archive-specific selectors/keys:
 *   - listSelector     {string}   jQuery selector for the post list. Default: '.js-blog-list'.
 *   - buttonsSelector  {string}   jQuery selector for the buttons wrapper. Default: '.blog__buttons'.
 *   - buttonsResponseKey {string} Key on the AJAX response containing updated buttons HTML.
 * Default: 'blog_buttons'.
 *   - onSuccess        {Function} Optional callback fired after posts and buttons are updated.
 */
function load_posts_ajax($buttonElement, data, insertMode = "append", options = {}) {
    // Default options object with destructuring and their values.
    const {
        listSelector       = '.js-blog-list',
        buttonsSelector    = '.blog__buttons',
        buttonsResponseKey = 'blog_buttons',
        onSuccess          = null,
    } = options;

    let currentPage;

    if (insertMode === "replace") {
        // Reset the current page to 0 when replacing posts, so that the next page will be 1.
        currentPage = 0;
    }
    else {
        // Get the current page number from the button's data attribute.
        currentPage = parseInt($buttonElement.data('current-page'), 10);
    }

    // Start from the next page
    const page = currentPage + 1;

    $buttonElement.addClass('loading');

    $.ajax({
        url: ajax_object.ajax_url,
        type: 'post',
        data: {
            ...data,
            paged: page,
        },
        success: function (response) {
            const total_pages = response.pagination.total;
            const $buttons    = $(buttonsSelector);
            const $list       = $(listSelector);

            // Depending on the insertMode, either append or replace the existing posts.
            if (insertMode === "append") {
                $list.append(response.posts_html);
            } else if (insertMode === "replace") {
                $list.html(response.posts_html);
            }

            // Update the buttons with the new pagination data.
            $buttons.html(response[buttonsResponseKey]);

            checkAnimateInElements();

            if (onSuccess) {
                onSuccess();
            }

            if (total_pages <= 1 || page >= total_pages) {
                $buttons.hide();
            }
            else {
                $buttons.show();
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            console.error('load_posts_ajax error:', textStatus, errorThrown, jqXHR);
            $buttonElement.removeClass('loading');
            const $error = $('<p class="blog__load-error">Something went wrong. Please try again.</p>');
            $buttonElement.closest(buttonsSelector).after($error);
            setTimeout(() => $error.remove(), 4000);
        }
    });
}
